


























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class SwitchWithTooltip extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean
  @Prop({ type: String, default: '' }) readonly description!: string
  @Prop({ type: String, default: 'blue darken-2' }) readonly color!: string

  show = false

  private onDocPointerDown!: (e: Event) => void
  private onAnyScroll!: () => void
  private onWindowBlur!: () => void
  private onVisibilityChange!: () => void
  private onFocusIn!: (e: Event) => void

  get internalValue(): boolean {
    return this.value
  }

  set internalValue(val: boolean) {
    this.$emit('input', val)
  }

  mounted() {
    this.onDocPointerDown = (e: Event) => {
      const target = e.target as Node | null
      if (!target) return
      if (!this.$el.contains(target)) this.show = false
    }
    document.addEventListener('pointerdown', this.onDocPointerDown, true)

    this.onAnyScroll = () => {
      if (this.show) this.show = false
    }
    window.addEventListener('scroll', this.onAnyScroll, true)

    this.onWindowBlur = () => {
      this.show = false
    }
    window.addEventListener('blur', this.onWindowBlur)

    this.onVisibilityChange = () => {
      if (document.hidden) this.show = false
    }
    document.addEventListener('visibilitychange', this.onVisibilityChange)

    this.onFocusIn = (e: Event) => {
      const target = e.target as Node | null
      if (!target) return
      if (!this.$el.contains(target)) this.show = false
    }
    document.addEventListener('focusin', this.onFocusIn, true)
  }

  beforeDestroy() {
    document.removeEventListener('pointerdown', this.onDocPointerDown, true)
    window.removeEventListener('scroll', this.onAnyScroll, true)
    window.removeEventListener('blur', this.onWindowBlur)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    document.removeEventListener('focusin', this.onFocusIn, true)
  }
}
